import { observer } from 'mobx-react-lite'
import { useAiAgentIndex } from 'app/components/ai-agent-index/useAiAgentIndex'
import { AiAgentIndexComponent } from 'app/components/ai-agent-index/AiAgentIndexComponent'

const AIAgentIndex = observer(function AIAgentIndex() {
  const hookData = useAiAgentIndex({
    getLocationHref: (id) => `/settings/ai-agent/${id}`,
    singleLocationRedirect: (id) => `/settings/ai-agent/${id}/settings`,
  })
  return <AiAgentIndexComponent {...hookData} />
})

export default AIAgentIndex
